import React from 'react';
import { MessageCircle, Calendar, SlidersHorizontal } from 'lucide-react';
interface TopBarProps {
  onCalendarClick?: () => void;
  onChatClick?: () => void;
}
export function TopBar({
  onCalendarClick,
  onChatClick
}: TopBarProps) {
  return <div className="px-4 py-6 flex items-center gap-3 bg-neutral-bg sticky top-0 z-10" data-id="element-105">
      {/* Chat Icon */}
      <button className="relative hover:bg-white/50 rounded-full p-2 transition-colors flex-shrink-0" aria-label="Team Chat" onClick={onChatClick} data-id="element-106">
        <MessageCircle className="w-6 h-6 text-gray-500" strokeWidth={2} data-id="element-107" />
        <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-neutral-bg" data-id="element-108"></span>
      </button>

      {/* Search Bar */}
      <div className="flex-1 relative" data-id="element-109">
        <input type="text" className="block w-full pl-6 pr-14 py-4 rounded-full border-0 text-gray-900 bg-white placeholder:text-gray-400 placeholder:text-base focus:ring-2 focus:ring-accent focus:outline-none shadow-[0_4px_20px_rgba(0,0,0,0.08)] text-base" placeholder="Search in clients" data-id="element-110" />
        <button className="absolute inset-y-0 right-0 pr-4 flex items-center hover:opacity-70 transition-opacity" aria-label="Filter options" onClick={() => console.log('Filter clicked')} data-id="element-111">
          <SlidersHorizontal className="h-5 w-5 text-gray-500" strokeWidth={2} data-id="element-112" />
        </button>
      </div>

      {/* Calendar Icon */}
      <button className="relative hover:bg-white/50 rounded-full p-2 transition-colors flex-shrink-0" aria-label="Calendar and notifications" onClick={onCalendarClick} data-id="element-113">
        <Calendar className="w-6 h-6 text-gray-500" strokeWidth={2} data-id="element-114" />
        <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-neutral-bg" data-id="element-115"></span>
      </button>
    </div>;
}